import React from 'react';
import { DEFAULT_HIDDEN_PAGINATION_PAGE_SIZE } from 'swag-client-common/constants';
import classes from './hidden-pagination.scss';
const CANONICAL = 'canonical';
const NEXT = 'next';
const PREV = 'prev';
export function createControls({
  location,
  pageSize = DEFAULT_HIDDEN_PAGINATION_PAGE_SIZE,
  currentPage = 0,
  currentPerPage,
  pageCount,
  isHead = false
}) {
  const controls = [];
  for (let i = 1; i <= pageCount; i++) {
    const rel = (() => {
      if (currentPerPage !== DEFAULT_HIDDEN_PAGINATION_PAGE_SIZE && i === 1) {
        return NEXT;
      }
      if (currentPerPage !== DEFAULT_HIDDEN_PAGINATION_PAGE_SIZE) {
        return null;
      }
      if (i === currentPage) {
        return CANONICAL;
      } else if (i === currentPage - 1) {
        return PREV;
      } else if (i === currentPage + 1) {
        return NEXT;
      }
      return null;
    })();
    const isPrevRelOnSecondPage = currentPage === 2 && rel === PREV;
    if (isHead) {
      if (!rel || rel === CANONICAL) {
        continue;
      }
      const href = isPrevRelOnSecondPage ? `${window.location.origin}${location.pathname}` : `${window.location.origin}${location.pathname}?page=${i}&perpage=${pageSize}`;
      // @todo. auto generated. fix this error
      // @ts-ignore
      controls.push( /*#__PURE__*/React.createElement("link", {
        rel: rel,
        href: href,
        key: href
      }));
    } else {
      const href = isPrevRelOnSecondPage ? `${location.pathname}` : `${location.pathname}?page=${i}&perpage=${pageSize}`;
      controls.push(
      /*#__PURE__*/
      // @todo. auto generated. fix this error
      // @ts-ignore
      React.createElement("a", {
        rel: rel,
        href: href,
        key: href
      }, i));
    }
  }
  return controls;
}
export default function Pagination(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.hiddenPagination
  }, createControls(props));
}